export default __webpack_public_path__ + "06002ef166587ecb4ab9d73748f5dcd3.png";